import type { TableOfContentsHeading } from '~/types';
import { safeToLowerCase } from './string';

export function slugifyHeading(value?: unknown): string {
  if (typeof value !== 'string') return '';

  return safeToLowerCase(value)
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-');
}

export function getHeadingElements(
  container: HTMLElement | null,
  headingSelector: string
): HTMLElement[] {
  if (!container) return [];
  return Array.from(container.querySelectorAll<HTMLElement>(headingSelector));
}

export function buildTableOfContentsFromContent(
  container: HTMLElement | null,
  headingSelector: string
): TableOfContentsHeading[] {
  const result: TableOfContentsHeading[] = [];
  if (!container) return result;

  const headings = getHeadingElements(container, headingSelector);
  const slugCounts = new Map<string, number>();

  headings.forEach((el) => {
    const text = (el.getAttribute('data-text') ?? '').trim();
    if (!text) return;

    if (!el.id) {
      const baseSlug = slugifyHeading(text);
      const count = slugCounts.get(baseSlug) ?? 0;
      slugCounts.set(baseSlug, count + 1);
      el.id = count === 0 ? baseSlug : `${baseSlug}-${count}`;
    }

    result.push({ id: el.id, text });
  });

  return result;
}
